import gql from 'graphql-tag';

const DAILY_COMPACT_FRAGMENT = gql`
	fragment serviceRunDailyCompact on ServiceRun {
		id
		created
		planned
		cashReconciliationStatus
		machineOrder
		routeOrderCalculationStatus
		routeOrderCalculationError
		order
		restockType
		ignoreSitePermissions
		brief
		briefAcknowledgedAt
		vehicleConfirmed
		myDayConfirmations {
			key
			at
		}
		driverClockSummary {
			clockedInAt
			clockedOutAt
			workedMinutes
		}
		driverShiftSummary {
			priorShiftDate
			priorShiftMinutes
			previousCycle {
				fromDate
				toDate
				totalMinutes
				allowanceMinutes
				days {
					date
					workedMinutes
					runningMinutes
				}
			}
			currentCycle {
				fromDate
				toDate
				totalMinutes
				allowanceMinutes
				days {
					date
					workedMinutes
					runningMinutes
				}
			}
		}
		checklistSubmissions {
			id
			purpose
			status
			flaggedItemIds
		}
		machineCount
		warehouse {
			id
			name
		}
		returnWarehouse {
			id
			name
		}
		route {
			id
			name
		}
		driver {
			id
			username
			firstname
			lastname
			destroyed
			userSitePermissions {
				id
				expiresAt
				sitePermission {
					id
					policy
				}
			}
		}
		vehicle {
			id
			name
			lastCoordinates
		}
		pickLists {
			id
			isAnyItemPicked
		}
		serviceDockets {
			id
			status
			date
			salesSinceLastRestock
			manualRestock
			manualRestockComment
			manualRestockApprovedBy {
				id
				firstname
				lastname
			}
			isRestocked
			startedProcessing
			inventoryCheck
			replacementReviewRequired
			replacementReviewReason
			inventoryPicked
			inventoryPartiallyPicked
			pickListGenerationStatus
			machineServiceType
			machineRestockType
			vendsSinceLastRestock
			someTicketsNotResolved
			ticketsResolved
			driverTicketCount
			collectCash
			cashCollected
			requirePhoto
			photoTaken
			permanentPackTags {
				id
				name
				abbreviation
			}
			packTags {
				id
				name
				abbreviation
			}
			inventoryChanges
			inventoryChangesPercentage
			inventoryChangesSelections
			order
			tub
			pickList {
				id
				isAnyItemPicked
			}
			serviceRun {
				id
			}
			place {
				id
				name
				destroyed
			}
			location {
				id
				name
				noteCount
				destroyed
			}
			machine {
				id
				type
				assetId
				brand
				destroyed
				place {
					id
					name
					destroyed
					serviceGroup {
						id
						name
						location {
							id
							name
						}
					}
				}
				location {
					id
					name
					noteCount
					destroyed
				}
				vendouts
				salesSinceLastRestock
				vendsSinceLastRestock
				openTicketCount
				openIssueTicketCount
				openMaintenanceTicketCount
				openJobTicketCount
				planogram {
					id
				}
				ingredientPlanogramId
				isOffline
				usesIngredients
				requiredSitePermissions {
					id
					name
					durationInDays
					daysOfWeek
					policy
					clients {
						id
					}
					locations {
						id
					}
					places {
						id
					}
					legacyMachines {
						id
					}
				}
				siteBookingNotices {
					id
					name
					bookingProcess
					clients {
						id
					}
					locations {
						id
					}
					places {
						id
					}
				}
			}
		}
	}
`;

export default DAILY_COMPACT_FRAGMENT;
